import { dependencies } from '@pn/core/dependencies';
import type { TableTemplate } from '@pn/core/domain/table';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { tableSlice } from './tableSlice';

export const useTableStorage = () => {
  const { name, getInitialState } = tableSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isError: useSliceSelector((state) => state.isError),
    isFetching: useSliceSelector((state) => state.isFetching),
    tableFields: useSliceSelector((state) => state.tableFields),
    selectedTemplates: useSliceSelector((state) => state.selectedTemplates),
    templates: useSliceSelector((state) => state.templates),
  };
};

export const tableActions = () => {
  const { dispatch } = dependencies.store;
  const { actions } = tableSlice;

  return {
    request: () => dispatch(actions.request()),
    receive: (templates: TableTemplate[]) =>
      dispatch(actions.receive(templates)),
    error: () => dispatch(actions.error()),
    create: (template: TableTemplate) => dispatch(actions.create(template)),
    remove: (template: TableTemplate) => dispatch(actions.remove(template)),
    select: (template: TableTemplate) => dispatch(actions.select(template)),
    updateTableFields: (sourceLayerId: string, fields: string[]) =>
      dispatch(actions.updateTableFields({ sourceLayerId, fields })),
    addTableFields: (sourceLayerId: string, fields: string[]) =>
      dispatch(actions.addTableFields({ sourceLayerId, fields })),
    removeTableFields: (sourceLayerId: string, fields: string[]) =>
      dispatch(actions.removeTableFields({ sourceLayerId, fields })),
    sync: (
      tableFields: Record<string, string[] | undefined>,
      selectedTemplates: Record<string, TableTemplate | undefined>
    ) => dispatch(actions.sync({ tableFields, selectedTemplates })),
  };
};
